import { Grid as MuiGrid } from "@mui/material";
import StudyTable from "app/components/study/StudyTable";

const StudyListingPageContent = (props) => {
  return (
    <MuiGrid container>
      <MuiGrid size={12}>
        <StudyTable />
      </MuiGrid>
    </MuiGrid>
  );
};

export default StudyListingPageContent;
